import React from 'react';
import { ForbiddenErrorPage } from 'components/error-pages/forbidden';

export const ForbiddenPage: React.FC = () => <ForbiddenErrorPage />;
